import { Button } from "@mui/material";
import CustomizedSnackbar from "components/CustomizedSnackbar";
import { useRegisterSW } from "virtual:pwa-register/react";

import appVersionIsBigger from "utils/appVersionIsBigger";
import useBoundStore from "store";
import { appVersion } from "utils/env";

interface ServiceWorkerProps {
  children: React.ReactNode;
}

function ServiceWorkerWrapper(props: ServiceWorkerProps): JSX.Element {
  const { children } = props;
  const userAuth = useBoundStore((state) => state.user.auth);
  const appStatus = useBoundStore((state) => state.miscellaneous.appStatus);
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW();

  const handleRefreshPage = () => {
    updateServiceWorker(true);
  };

  return (
    <>
      <CustomizedSnackbar
        action={
          <Button color='inherit' size='small' onClick={handleRefreshPage}>
            Refresh
          </Button>
        }
        autoHideOff
        message='Refresh to update app.'
        onClose={handleRefreshPage}
        open={needRefresh && (!appVersionIsBigger(appStatus?.update.version, appVersion) || !userAuth)}
        severity='info'
      />
      {children}
    </>
  );
}

export default ServiceWorkerWrapper;
